import React from "react";

const CloudUploadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
    >
      <mask
        id="mask0_18490_84821"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="33"
        height="32"
      >
        <rect x="0.5" width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_18490_84821)">
        <path
          d="M9.16667 26C7.324 26 5.75222 25.3608 4.45133 24.0823C3.15044 22.8039 2.5 21.2414 2.5 19.395C2.5 17.7386 3.03289 16.2817 4.09867 15.0243C5.16444 13.767 6.48622 13.0221 8.064 12.7897C8.49133 10.7966 9.49356 9.16667 11.0707 7.9C12.6476 6.63333 14.4573 6 16.5 6C18.9142 6 20.9622 6.84089 22.644 8.52267C24.3258 10.2044 25.1667 12.2524 25.1667 14.6667V15.3333H25.577C26.9821 15.4427 28.1539 16.0077 29.0923 17.0283C30.0308 18.0488 30.5 19.2616 30.5 20.6667C30.5 22.1538 29.9872 23.4144 28.9617 24.4487C27.9359 25.4829 26.6795 26 25.1923 26H17.9103C17.2368 26 16.6667 25.7667 16.2 25.3C15.7333 24.8333 15.5 24.2632 15.5 23.5897V16.287L13.0333 18.7127L11.6283 17.3207L16.5 12.4487L21.3717 17.3207L19.9667 18.7127L17.5 16.287V23.5897C17.5 23.6923 17.5428 23.7863 17.6283 23.8717C17.7137 23.9572 17.8077 24 17.9103 24H25.1667C26.1 24 26.8889 23.6778 27.5333 23.0333C28.1778 22.3889 28.5 21.6 28.5 20.6667C28.5 19.7333 28.1778 18.9444 27.5333 18.3C26.8889 17.6556 26.1 17.3333 25.1667 17.3333H23.1667V14.6667C23.1667 12.8222 22.5167 11.25 21.2167 9.95C19.9167 8.65 18.3444 8 16.5 8C14.6556 8 13.0833 8.65 11.7833 9.95C10.4833 11.25 9.83333 12.8222 9.83333 14.6667H9.141C7.87767 14.6667 6.78833 15.1222 5.873 16.0333C4.95767 16.9444 4.5 18.0444 4.5 19.3333C4.5 20.6222 4.95556 21.7222 5.86667 22.6333C6.77778 23.5444 7.87778 24 9.16667 24H12.5V26H9.16667Z"
          fill="#12B6EA"
        />
      </g>
    </svg>
  );
};

export default CloudUploadIcon;
